import * as React from "react";

const SvgSearch = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31 31 21 21l10 10Zm-6.667-18.333a11.667 11.667 0 1 1-23.333 0 11.667 11.667 0 0 1 23.333 0Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgSearch;
